import React from 'react';
import { MdArrowForwardIos } from 'react-icons/md';
import GrowthwiseImage from '../Assets/Image/jason-goodman.jpg';
import { useNavigate } from 'react-router-dom';

export const Growthwise = () => {
  const navigate = useNavigate();

  return (
    <section className='px-4 sm:px-10 md:px-20 bg-t-wh py-16'>
      <div className='mx-auto gap-8 flex flex-col max-w-[1440px]'>
        <div className='space-y-2'>
          <h3 className='text-b-mc '>GROWTHWISE</h3>
          <h2 className='text-2xl font-semibold'>We are Innovative </h2>
        </div>
        <div className='gap-x-20 gap-y-10 w-full grid lg:grid-cols-2'>
          <div className='flex flex-col gap-12 col-span-1'>
            <div className='space-y-2'>
              <h3 className='font-semibold text-lg'>
                Innovative social commerce platform.
              </h3>
              <p className='leading-relaxed'>
                Loyalty View is an innovative platform built from a need to
                create a secure and trusted ecosystem where members can safely
                trade without the fear of being taken advantage of.
              </p>
              <p className='leading-relaxed'>
              We are able to guarantee safe transactions by using the latest AML 
              and transaction monitoring technologies and well tested business 
              workflows to give optimum customer experience.
              </p>
            </div>
            <button
              className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-3 w-fit h-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md relative flex flex-row gap-4 items-center'
              onClick={() => navigate('/signin')}
            >
              Get Started
              <span className='rounded-md text-sm'>
                <MdArrowForwardIos />
              </span>
            </button>
          </div>
          <img src={GrowthwiseImage} alt='img' className='col-span-1' />
        </div>
      </div>
    </section>
  );
};
